module.exports = __webpack_public_path__ + "static/face-4ff735ec75306ed674e7156c7d49c02e.jpg";